<template>



    <booking-cancel></booking-cancel>

   

    <div class="stay">
        <div class="search">
            <img class="tc-logo" src="/Assets/img/booking/travellers-choice.svg" />

            <div class="booking-container-n">
                <div class="page-intro">
                    <h1>Book a room</h1>
                    <!--<button class="btn btn--transparent-dark btn--highlight-after" v-on:click="onMapModalToggle()">View Accomodation Map</button>-->
                </div>

                <div class="container" v-if="isDisabled">
                    <div class="row mb-5 ">
                        <div class="col-xl-24 text-center">
                            <div class=" p-3 bg-white" v-html="operaStatus.BookingMessage">
                            </div>
                        </div>
                    </div>
                </div>


            </div>

            <div v-if="isLoading" class="mt-5 d-flex justify-content-center">
                <loader></loader>
            </div>

            <div class="booking-container-n" v-else>
                <div class="container" v-if="!isDisabled">
                    <div class="row mb-5">
                        <div class="col-xl-24 mb-3 text-center">
                            <h3 class="form-group-title">When would you like to stay?</h3>
                        </div>
                        <div class="col-24">
                            <div class="row justify-content-center">
                                <div class="mb-3  col-24 col-xl-12 mb-xl-0">

                                    <v-date-picker v-if="!isReadonly"
                                                   class="inline-block h-full"
                                                   v-model="date"
                                                   v-bind:locale="locale"
                                                   v-bind:min-date='minDate'
                                                   v-bind:max-date='maxDate'>
                                        <template v-slot="{ inputValue, togglePopover }">
                                            <div class="flex items-center" @click="togglePopover()">
                                                <input v-bind:value="inputValue"
                                                       class="form-control search-date calendar"
                                                       readonly />
                                            </div>
                                        </template>
                                    </v-date-picker>

                                    <input v-else v-bind:value="formatedDate()"
                                           class="form-control search-date calendar on"
                                           readonly />

                                </div>
                                <div class="mb-3 col-24 col-xl-12 mb-lg-0">
                                    <select v-if="!isReadonly" class="form-select calendar" v-model="numberOfNights">
                                        <option value="1">1 night</option>
                                        <option value="2">2 nights</option>
                                        <option value="3">3 nights</option>
                                        <option value="4">4 nights</option>
                                        <option value="5">5 nights</option>
                                        <option value="6">6 nights</option>
                                        <option value="7">7 nights</option>
                                        <option value="8">8 nights</option>
                                        <option value="9">9 nights</option>
                                        <option value="10">10 nights</option>
                                        <option value="11">11 nights</option>
                                        <option value="12">12 nights</option>
                                        <option value="13">13 nights</option>
                                        <option value="14">14 nights</option>
                                    </select>

                                    <input v-else v-model="numberOfNights"
                                           class="form-control calendar"
                                           readonly />

                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="!amendId" class="row mb-5">
                        <div class="col-xl-24 text-center  mb-3">
                            <h3 class="form-group-title">How many rooms would you like to book?</h3>
                        </div>
                        <div class="col-xl-24 d-flex justify-content-center">
                            <ul class="rad-btn-list">
                                <li>
                                    <input id="rc1" type="radio" value="1" name="rc" v-model="roomCount" v-on:change="onRoomCountChange()" />
                                    <label for="rc1">1</label>
                                </li>
                                <li>
                                    <input id="rc2" type="radio" value="2" name="rc" v-model="roomCount" v-on:change="onRoomCountChange()" />
                                    <label for="rc2">2</label>
                                </li>
                                <li>
                                    <input id="rc3" type="radio" value="3" name="rc" v-model="roomCount" v-on:change="onRoomCountChange()" />
                                    <label for="rc3">3</label>
                                </li>
                                <li>
                                    <input id="rc4" type="radio" value="4" name="rc" v-model="roomCount" v-on:change="onRoomCountChange()" />
                                    <label for="rc4">4</label>
                                </li>
                                <li>
                                    <input id="rc5" type="radio" value="0" name="rc" v-model="roomCount" v-on:change="onRoomCountChange()" />
                                    <label for="rc5">5+</label>
                                </li>
                            </ul>
                        </div>
                    </div>


                    <div class="room-configurations mb-5" v-if="roomCount > 0">
                        <div class="row d-flex justify-content-center">


                            <div class="col-24 col-lg-12 mb-3"
                                 v-bind:key="room.index"
                                 v-for="(room, index) in guestOccupancies">
                                <div class="bg-white room-configuration">
                                    <h4 class="title">Guests in Room {{index + 1}}</h4>


                                    <div class="row">
                                        <div class="col-12">
                                            <spinner v-on:value-change="(value) => room.adults = value"
                                                     v-bind:initial="room.adults"
                                                     v-bind:min="1"
                                                     v-bind:max="configuration.MaxAdults"
                                                     v-bind:label="'Adults'"></spinner>
                                        </div>

                                        <div class="col-12">
                                            <spinner v-on:value-change="(value) => onChildCountChange(room, value)"
                                                     v-bind:initial="room.childCount"
                                                     v-bind:min="0"
                                                     v-bind:max="configuration.MaxChildren"
                                                     v-bind:label="'Children'"></spinner>

                                        </div>


                                        <!--<div class="col-8">
                                            <spinner v-on:value-change="(value) => room.dogs = value"
                                                     v-bind:initial="room.dogs"
                                                     v-bind:min="0"
                                                     v-bind:max="2"
                                                     v-bind:label="'Dogs'"></spinner>

                                        </div>-->


                                        <div v-if="room.childCount > 0" class="row">
                                            <div v-for="(child, index) in room.children"
                                                 v-bind:key="index"
                                                 class="col-24 mb-3">
                                                <h4 class="title">Child Age</h4>
                                                <select v-model="child.age" class="form-select">
                                                    <option value="0">Under 1</option>
                                                    <option value="1">1 year old</option>
                                                    <option value="2">2 years old</option>
                                                    <option value="3">3 years old</option>
                                                    <option value="4">4 years old</option>
                                                    <option value="5">5 years old</option>
                                                    <option value="6">6 years old</option>
                                                    <option value="7">7 years old</option>
                                                    <option value="8">8 years old</option>
                                                    <option value="9">9 years old</option>
                                                    <option value="10">10 years old</option>
                                                    <option value="11">11 years old</option>
                                                    <option value="12">12 years old</option>
                                                    <option value="13">13 years old</option>
                                                    <option value="14">14 years old</option>
                                                </select>

                                            </div>



                                        </div>

                                    </div>




                                </div>
                            </div>





                        </div>
                    </div>

                    <div v-else class="room d-flex justify-content-center">
                        <div class="col-12 mb-3">
                            <div class="rooms-exceeded">

                                <div v-html="content.exceedRoomLimit"></div>

                            </div>
                        </div>

                    </div>


                    <div class="row mb-5 justify-content-center">
                        <div class="col-24 col-xl-16">
                            <div class="form-group">
                                <div class="title-wrapper mb-3">
                                    <h3 class="form-group-title">Got a code?</h3>
                                    <button class="help" v-on:click="onVoucherModalToggle()">Help</button>
                                </div>

                                <div class="row g-0">
                                    <div class="col-xl-24">
                                        <input type="text" class="form-control" placeholder="Enter code" v-model="code" />
                                    </div>


                                </div>





                            </div>
                        </div>

                    </div>




                    <div class="row mb-5 justify-content-center">
                        <div class="col-24 col-xl-16">
                            <div class="form-group">
                                <div class="title-wrapper  mb-3">
                                    <h3 class="form-group-title">Got a voucher?</h3>
                                    <button class="help" v-on:click="onVoucherModalToggle()">Help</button>
                                </div>

                                <div class="row g-0">
                                    <div class="col-xl-16">
                                        <input type="text" class="form-control" placeholder="Enter code" v-model="voucherCode" />
                                    </div>

                                    <div class="col-xl-8">
                                        <button class="btn btn--gold btn--block"
                                                v-bind:disabled="isCheckingCode"
                                                type="button" v-on:click="onCheckCode()">
                                            Apply code
                                        </button>

                                    </div>
                                </div>


                                <div class="applied-codes mt-2 p-3" v-if="vouchers.length">
                                    <div class="row">
                                        <div class="col-24">
                                            <h4 class="title">Applied Vouchers</h4>
                                            <ul class="m-0">
                                                <li v-for="(appliedVoucher, index) in vouchers"
                                                    v-bind:key="index">
                                                    <div class="d-flex flex-column">
                                                        <span>
                                                            {{appliedVoucher.voucher.orderItemId}} - {{appliedVoucher.voucher.voucherName}}
                                                        </span>
                                                        <span class="mt-1">

                                                            The value of your voucher is £{{appliedVoucher.voucher.unitPrice.amount}}
                                                        </span>
                                                    </div>

                                                    <button type="button" class="remove" v-on:click="onRemoveVoucher(appliedVoucher)">Remove</button>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>


                                <div class="applied-codes applied-codes--invalid mt-2 p-3" v-if="invalidVouchers.length">
                                    <div class="row">
                                        <div class="col-24">
                                            <h4 class="title">Invalid Vouchers</h4>
                                            <ul class="m-0">
                                                <li v-for="(invalidVoucher, index) in invalidVouchers"
                                                    v-bind:key="index">
                                                    <div class="d-flex flex-column">

                                                        <span>{{invalidVoucher.voucher.voucher.orderItemId}} <span v-if="invalidVoucher.voucher.voucher.voucherName">- {{invalidVoucher.voucher.voucher.voucherName}}</span></span>
                                                        <span class="mt-1" v-if="invalidVoucher.reason"><strong>{{invalidVoucher.reason}}</strong></span>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>



                            </div>
                        </div>

                    </div>
                </div>



                <actions-bar v-if="!isDisabled">

                    <template v-slot:actions>
                        <div class="row" v-if="showVoucherOccupancyError">
                            <div class="col-24 d-flex justify-content-end mb-3">
                                <span class="voucher-error">Stay vouchers can only be redeemed with a single room booking.</span>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-24 d-flex justify-content-end">
                                <button class="btn btn--slate-blue btn--continue"
                                        v-bind:disabled="isButtonDisabled"
                                        v-on:click="onContinue">
                                    Check Availability
                                </button>
                            </div>
                        </div>
                    </template>
                </actions-bar>


            </div>
        </div>
    </div>

    <standard-modal v-if="modalMapVisible" v-on:close="modalMapVisible = false">
        <template v-slot:header>
            <h2 class="mb-5">Accommodation Map</h2>
        </template>
        <template v-slot:body>
            <img style="width: 100%" src="/Assets/img/booking/accomodationmap.png?width=700" />
        </template>
    </standard-modal>

    <standard-modal v-if="modalVouchersVisible" v-on:close="modalVouchersVisible = false">

        <template v-slot:header>
            <h2 class="mb-5">How to use Voucher Codes</h2>
        </template>
        <template v-slot:body>

            <div class="row mb-5" v-for="(giftVoucher, index) in content.giftVouchers"
                 v-bind:key="index">
                <div class="col-8 d-flex justify-content-center">
                    <div v-if="giftVoucher.Image"
                         class="voucher-code-image">
                        <span class="has-bg-image bg-full"
                              role="img"
                              v-bind:style="{ backgroundImage: 'url(' + giftVoucher.Image.Path + ')' }"></span>
                    </div>
                </div>
                <div class="col-16">
                    <h3>
                        {{giftVoucher.Title}}
                    </h3>
                    <div class="dottedborder" v-html="giftVoucher.Body">

                    </div>


                </div>
            </div>




        </template>
    </standard-modal>



    <standard-modal v-if="modalInvalidVouchersVisible" v-on:close="modalInvalidVouchersVisible = false;modalTextKey = null;">

        <template v-slot:header>
            <h2 class="mb-5">Invalid Voucher Code</h2>
        </template>
        <template v-slot:body>

            <div class="row mb-5">
                <div class="col-24 d-flex flex-column align-content-center text-center">

                    <div class="invalid-message">
                        <p v-if="modalKey == expiredKey">
                            Please note this gift experience cannot currently be redeemed online.
                        </p>
                        <p v-if="modalKey == categoryKey">
                            Please note this voucher cannot be redeemed against Overnight experiences online.
                        </p>
                        <p>
                            Please click <strong><a href="/contact">here</a></strong> to request to book your voucher with a member of the team. Thank you!
                        </p>
                    </div>
                </div>

            </div>




        </template>
    </standard-modal>

</template>

<script>
    import ActionsBar from '@/shared/components/ActionsBar.vue';
    import StandardModal from '@/shared/components/StandardModal.vue';
    import BookingCancel from '../components/BookingCancel.vue';

    import Spinner from '@/shared/components/Spinner.vue';


    import Loader from '@/shared/components/Loader.vue';
    import giftVoucher from '@/shared/api/giftVoucher';

    import { store } from '../store/index';

    export default {
        name: 'Search',
        components: {
            ActionsBar,
            BookingCancel,

            Spinner,
            StandardModal,
            Loader

        },
        computed: {
            isReadonly() {
                let result = false;

                if (this.vouchers != null && this.vouchers.length) {
                    result = true;
                }

                return result;
            },
            isDisabled() {
                return this.operaStatus != null && this.operaStatus.IsDisabled;
            },
            operaStatus() {
                return store.getters.operaSystemStatus;
            },
            session() {
                return store.getters.session
            },
            search() {
                return store.getters.search;
            },
            configuration() {
                return store.getters.roomConfiguration;
            },
            isButtonDisabled() {
                return this.roomCount == 0;
            },
            content() {
                return this.configuration.Content.search;
            },
            minDate() {
                if (this.session != null && this.session.BusinessDate != null) {
                    return new Date(this.session.BusinessDate);
                }
                return new Date();
            },
            maxDate() {
                var d = new Date();
                var year = d.getFullYear();
                var month = d.getMonth();
                var day = d.getDate();
                var c = new Date(year + 2, month, day);
                return c;
            },
            voucherCodes() {
                return this.vouchers.map(item => item.voucher.orderItemId.toString());
            }
        },
        data() {
            return {
                expiredKey: "expired",
                categoryKey: "category",
                roomCount: 1,
                guestOccupancies: [],
                date: new Date(),
                numberOfNights: 1,
                code: null,
                voucherCode: null,
                modalVouchersVisible: false,
                modalMapVisible: false,
                modalInvalidVouchersVisible: false,
                vouchers: [],
                invalidVouchers: [],
                isCheckingCode: false,
                showVoucherOccupancyError: null,
                modalTextKey: null,
                amendId: null,
                isLoading: false,
                locale: "en-GB",
            }

        },
        created() {

            this.isLoading = true;
            if (this.configuration == null) {
                store.dispatch('getConfiguration').then(() => {
                    store.dispatch('createSession').then((response) => {

                        this.onMount();
                        this.isLoading = false;
                    });
                });
            }
            else {
                store.dispatch('createSession').then((response) => {

                    this.onMount();
                    this.isLoading = false;
                });
            }
        },
        methods: {
            onMount() {
              
                this.onRoomCountChange();
                var iso = new Date().toISOString();
                iso = iso.substr(0, iso.indexOf('T'));
                this.date = iso;

                let search = this.search;

              
                if (this.$route.query.amend != null) {
                    search = null;

                }
                if (search != undefined && search != null) {
                    this.amendId = null;

                    this.roomCount = search.guestOccupancies.length;
                    this.onRoomCountChange();
                    this.guestOccupancies = search.guestOccupancies;
                    this.date = new Date(search.arrivalDate);
                    this.code = search.code;
                    this.numberOfNights = search.numberOfNights;

                    if (search.voucherCodes != null) {
                        for (let vi in search.voucherCodes) {
                            let v = search.voucherCodes[vi];
                            this.voucherCode = v;
                            this.onCheckCode();
                        }
                    }
                } else {

                    if (this.$route.query.amend != null) {
                        this.amendId = this.$route.query.amend;

                    } else {
                        this.amendId = null;
                    }

             
                    this.code = this.$route.query.code || null;
                    this.numberOfNights = this.$route.query.numberOfNights || 1;
                    
                    this.date = this.$route.query.arrivalDate != null ? new Date(this.$route.query.arrivalDate) : new Date();


                    if (this.$route.query.occupancy != null) {
                        var occupancy = JSON.parse(this.$route.query.occupancy);
                        this.roomCount = occupancy.length;
                        this.onRoomCountChange();

                        this.guestOccupancies = [];
                        for (let oi = 0; oi < occupancy.length; oi++) {
                            let o = occupancy[oi];
                    
                            let adults = o[0];
                            let children = o[1];
                            let dogs = o[2];

                            let childAges = [];
                            if (children > 0) {
                                for (var c = 0; c < children; c++) {
                                    childAges.push({ index: c, age: 0 });
                                }
                            }


                            this.guestOccupancies.push({ adults: adults, childCount: children, children: childAges, dogs: dogs });

                        }

                    }

                }
            },
            onRemoveVoucher(voucher) {
                this.vouchers.pop(voucher);
            },
            onCheckCode() {
                this.isCheckingCode = true;
                let o = this;
                let voucherDate = moment(this.date).format("YYYY-MM-DD");
                if (this.voucherCode != null && this.voucherCode.length && !this.voucherCodes.includes(this.voucherCode)) {
                    giftVoucher.checkStatus(this.voucherCode, voucherDate, function (t) {

                        if (t.isAvailableOnline && t.canBeUsed && (t.content.Category == 0 || t.content.Category == 1)) {
                            o.vouchers.push(t);
                        }
                        else {

                            if (t.isRedeemed) {
                                o.invalidVouchers.push({ voucher: t, reason: 'Already used' });
                            }
                            else if (t.isOutsidePeriod) {
                                o.modalInvalidVouchersVisible = true;
                                o.modalTextKey = o.expiredKey;
                                o.invalidVouchers.push({ voucher: t, reason: 'Voucher invalid for booking date' });
                            }
                            else if (t.isBooked) {
                                o.invalidVouchers.push({ voucher: t, reason: 'Already used' });
                            }
                            else if (!t.isAvailableOnline) {
                                o.invalidVouchers.push({ voucher: t, reason: 'Cannot be used online' });
                            }
                            else if (t.content.Category != 0 && t.content.Category != 1) {
                                o.modalInvalidVouchersVisible = true;
                                o.modalTextKey = o.categoryKey;
                                o.invalidVouchers.push({ voucher: t, reason: 'Invalid category' });
                            }

                            else {
                                o.invalidVouchers.push({ voucher: t, reason: '' });
                            }
                        }
                        o.voucherCode = null;
                        o.isCheckingCode = false;
                    }, function (t) {

                        o.invalidVouchers.push({ voucher: { voucher: { orderItemId: o.voucherCode } }, reason: 'Cannot be found' });

                        o.voucherCode = null;
                        o.isCheckingCode = false;
                    }



                    )

                }




            },
            onRoomCountChange: function () {
                var roomCount = +this.roomCount;
                if (roomCount > this.guestOccupancies.length) {
                    var numberToAdd = this.guestOccupancies.length;
                    for (var i = 0; i < roomCount - numberToAdd; i++) {
                        this.guestOccupancies.push({ adults: 2, childCount: 0, children: [], dogs: 0 });
                    }
                }
                else {
                    this.guestOccupancies.splice(+this.roomCount);
                }
            },
            onChildCountChange: function (room, value) {
                room.childCount = value;

                if (value > room.children.length) {
                    for (var i = 0; i <= value - room.children.length; i++) {
                        room.children.push({ index: i, age: 0 });
                    }
                }
                else {
                    room.children.splice(+value);
                }

            },
            onContinue: function () {


              

                var anyNonMonetary = false;
                for (var vi in this.vouchers) {
                    var voucher = this.vouchers[vi];
                    anyNonMonetary = !voucher.content.IsMonetary;
                }

                this.showVoucherOccupancyError = anyNonMonetary && this.guestOccupancies.length > 1;


                if (this.showVoucherOccupancyError) {
                    return;
                }

                var search = {
                    sessionId: this.session.Id,
                    arrivalDate: moment(this.date).format("YYYY-MM-DD"),
                    numberOfNights: this.numberOfNights,
                    guestOccupancies: this.guestOccupancies,
                    code: this.code,
                    voucherCodes: this.voucherCodes,
                    amendId: this.amendId
                };

                //GTM tracking
                this.track();

                store.dispatch("ignoreBooking").then(() => {
                    store.dispatch("clearPartialData").then(() => {
                        store.dispatch('setSearch', search).then(() => {

                            let bookingPayload = {
                                monetaryVouchers: this.vouchers,
                                amendId: this.amendId
                            };

                            store.dispatch('createBooking', bookingPayload);
                            this.$router.push({ name: 'stay_leg_room_availability', params: { id: this.session.Id, leg: 1 } });
                        });

                    });
                });


            },
            onVoucherModalToggle: function () {
                this.modalVouchersVisible = !this.modalVouchersVisible;
            },
            onMapModalToggle: function () {
                this.modalMapVisible = !this.modalMapVisible;
            },
            formatedDate() {
                return moment(this.date).format("DD/MM/YYYY");
            },
            track() {

                if (this.$gtm.enabled()) {

                    let occupancies = [];
                    for (let i = 0; i < this.guestOccupancies.length; i++) {
                        let occup = this.guestOccupancies[i];
                        let ages = [];
                        for (let y = 0; y < occup.children.length; y++)
                        {
                            let childages = occup.children[y];
                            let age = {
                                'child': (y+1),
                                'age': childages.age
                            };
                            ages.push(age);
                        }
                        let occupancy = {
                            'room': (i+1),
                            'adults': occup.adults,
                            'children': occup.children.length,
                            'childrenAges': ages,
                            'dogs': occup.dogs
                        };
                        occupancies.push(occupancy);
                    }

                    var arrival = moment(this.date).format("YYYY-MM-DD");
                    var departure = moment(this.date).add(this.numberOfNights, 'days').format("YYYY-MM-DD");
                    var duration = this.numberOfNights;

                    window.dataLayer?.push({
                        'pageURL': '/stay/search/',
                        'event': 'roomSearch',
                        'arrivalDate': arrival,
                        'departureDate': departure,
                        'promoCode': this.code,
                        'voucherCode': this.voucherCodes,
                        'roomCount': this.guestOccupancies.length,
                        'occupancies': occupancies,
                        'stayDuration': duration
                    });
                }
            },



        }
    }
</script>


<style src="@/shared/css/search.css"></style>


<style scoped>
    .applied-codes {
        background-color: rgba(52,127,52,0.15);
        padding-left: 55px !important;
        background-size: 26px 26px;
        background-image: url(/Assets/img/website/tick.svg);
        background-repeat: no-repeat;
        background-position: 16px 16px;
    }

        .applied-codes ul {
            padding: 0;
        }

            .applied-codes ul li {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
            }


                .applied-codes ul li::marker {
                    color: black;
                }

                .applied-codes ul li .remove {
                    border: none;
                    background: transparent;
                    cursor: pointer;
                    text-indent: -9999px;
                    background-size: 15px 15px;
                    background-image: url(/Assets/img/booking/cross.svg);
                    background-repeat: no-repeat;
                    background-position: center center;
                    height: 15px;
                    width: 15px;
                }



    .applied-codes--invalid {
        background-image: url(/Assets/img/booking/exclamation.svg);
        background-color: rgba(161,143,91,0.2);
    }

    .applied-codes .title {
        font-weight: bold;
        font-size: 16px;
        font-family: Montserrat;
    }

    .voucher-error {
        color: rgb(161, 0, 0);
        font-weight: bold;
    }

    .invalid-message p {
        font-size: 20px;
    }
</style>
